import moment from 'moment'

import { OnSchedTemplates } from "../OnSchedTemplates";
import { OnSchedHelpers }   from "../utils/OnSchedHelpers";
import googleIcon           from '../assets/img/google.png';
import outlookIcon          from '../assets/img/outlook.png';


export const resourcesList = response => {
  const tmplResources = `
      <div class="onsched-container">
          <div class="onsched-row">
              <div class="onsched-col">
                  <div class="onsched-list">
                      <div class="onsched-table">
                          ${response.data.map((resource, index) =>
                              `<div class="row">
                                  <div class="icon-col">
                                  ${ resource.imageUrl == undefined || resource.imageUrl.length == 0 ?
                                      OnSchedTemplates.circleIcon(resource.name) : OnSchedTemplates.listImage(resource.imageUrl)
                                  }
                                  </div>
                                  <div class="info-col">
                                      <a href="#" class="list-item name" data-id=${resource.id} data-element="resources" 
                                          title="Click to book this service">
                                          ${resource.name}
                                      </a>
                                      <div class="list-item-description">${resource.description}</div>
                                  </div>
                               </div>`
      ).join("")}
                      </div>
                  </div>
              </div>
          </div>
      </div>
  `;
  return tmplResources;
}

export const resourceSetup = (element, data, customFieldsArray) => {
  const tmplResourceSetup = `
  <div class="onsched-container">
  <form class="onsched-wizard onsched-form" name="resourceSetup">
      <input type="hidden" name="step" value="0" />
      ${resourceSetupGeneralInformation(element, data)}

      ${resourceSetupContactInformation(element, data)}

      ${resourceSetupAddress(element, data)}

      ${resourceSetupCustomFields(customFieldsArray)}
      
      ${element.options.allocations ? resourceSetupAvailabilityAllocations(element, data) : resourceSetupAvailability(element, data)}
      
      ${element.options.blocks ? resourceSetupAvailabilityBlocks(element, data) : ''}

      <div class="onsched-wizard-nav">
          <div style="display:table-row">
              <div class="onsched-wizard-nav-status">
                  <!-- Circles which indicates the steps of the form: -->
              </div>
              <div class="onsched-wizard-nav-buttons">
                  <button type="button" id="prevButton" class="prevButton">Previous</button>
                  <button type="submit" id="nextButton" class="nextButton">Next</button>
              </div>
          </div>
      </div>
  </form>
</div>        
  `;

  return tmplResourceSetup;
}

const resourceSetupGeneralInformation = (element, data) => {
  const markup = `
  <div class="onsched-wizard-section">
  <div class="onsched-form-row">
      <div class="onsched-form-col">
          ${element.options.labels ? '<label for="resourceName">Name</label>' : ''}
          <input id="resourceName" placeholder="Name" type="text" name="name" value="${OnSchedHelpers.DataValue(data.name)}" required="required" data-post="root"/>
      </div>
      <div class="onsched-form-col">
          ${element.options.labels ? '<label for="resourceTimezone">Timezone</label>' : ''}
          ${OnSchedTemplates.TimezoneSearch}
      </div>
  </div>
  <div class="onsched-form-row">
      <div class="onsched-form-col">
          ${element.options.labels ? '<label for="email">Email</label>' : ''}
          <input placeholder="Email" type="email" id="email" name="email" value="${OnSchedHelpers.DataValue(data.email)}" data-post="root"/>
      </div>
      <div class="onsched-form-col">
          ${element.options.labels ? '<label for="groupId">Group</label>' : ''}
          <div class="onsched-select">
            <select placeholder="Group" id="groupId" name="groupId"  value="${OnSchedHelpers.DataValue(data.groupId)}" data-post="root"></select>
          </div>
      </div>
  </div>
  <div class="onsched-form-row">
      <div class="onsched-form-col">
      ${element.options.labels ? '<label for="description">Description</label>' : ''}
      <textarea id="description" name="description" rows="3" placeholder="Enter Resource Description" data-post="root">${OnSchedHelpers.DataValue(data.description)}</textarea>                    
      </div>
  </div>
   <div class="onsched-form-row">
      <div class="onsched-form-col">
          ${element.options.labels ? '<label>Image preview</label>' : ''}
          ${OnSchedTemplates.previewImage(data)}
      </div>
      <div class="onsched-form-col">
          ${element.options.labels ? '<label>Upload Image</label>' : ''}
          <div>
              <input type="file" accept="image/*" id="onsched-system-file-upload" name="onsched-system-file-upload" hidden="hidden">
              <button type="button" class="onsched-file-upload-btn">Choose a file</button>
              <span id="onsched-file-upload-txt" class="onsched-file-upload-txt">No file chosen yet.</span>
          </div>
      </div>                    
  </div>               
</div>
  `;
  return markup;
}

const resourceSetupContactInformation = (element, data) => {
    const calendarProviders = { 0: 'OnSched', 1: 'Google', 2: 'Outlook' };

    var calendarSync = { 
        id: '',
        authorized: false,
        provider: calendarProviders[data.calendarAvailability],
      };
  
    if (data.googleCalendarAuthorized) {
        calendarSync.authorized = true;
        calendarSync.id = data['googleCalendarId'];
      }
    else if (data.outlookCalendarAuthorized) {
        calendarSync.authorized = true;
        calendarSync.id = data['outlookCalendarId'];
    }

  const markup = `
<div class="onsched-wizard-section">
  <div class="onsched-form-row">
      <div class="onsched-form-col">
          ${element.options.labels ? '<label for="businessPhone">Business Phone</label>' : ''}
          <input placeholder="Business Phone" type="tel" id="businessPhone" name="businessPhone"
              value="${OnSchedHelpers.DataValue(OnSchedHelpers.FormatPhoneNumber(data.contact.businessPhone))}" data-post="contact"/>
      </div>
      <div class="onsched-form-col">
          ${element.options.labels ? '<label for=""mobilePhone>Mobile Phone</label>' : ''}
          <input placeholder="Mobile Phone" type="tel" id="mobilePhone" name="mobilePhone" 
              value="${OnSchedHelpers.DataValue(OnSchedHelpers.FormatPhoneNumber(data.contact.mobilePhone))}" data-post="contact" />
      </div>
  </div>
  <div class="onsched-form-row">
      <div class="onsched-form-col">
          ${element.options.labels ? '<label for="homePhone">Home Phone</label>' : ''}
          <input placeholder="Home Phone" type="tel" id="homePhone" name="homePhone" 
              value="${OnSchedHelpers.DataValue(OnSchedHelpers.FormatPhoneNumber(data.contact.homePhone))}" data-post="contact" />
      </div> 
      <div class="onsched-form-col">
          ${element.options.labels ? '<label for="preferredPhoneType">Preferred Contact Phone</label>' : ''}
          <div class="onsched-select">
            <select placeholder="Preferred Contact Phone" class="form-control" id="preferredPhoneType" name="preferredPhoneType" value="${OnSchedHelpers.DataValue(data.contact.preferredPhoneType)}" data-post="contact">
                <option value="B" selected="selected">Business</option>
                <option value="M" selected="selected">Mobile</option>
                <option value="H">Home</option>
            </select>
          </div>
      </div>                                     
  </div>      
  <div class="onsched-form-row">
      <div class="onsched-form-col">
          ${element.options.labels ? '<label for="notificationType">Notification Type</label>' : ''}
          <div class="onsched-select">
            <select placeholder="Notification Type" id="notificationType" name="notificationType" value="${OnSchedHelpers.DataValue(data.notificationType)}" aria-required="true" aria-invalid="false" data-post="root">
                <option value="0"></option>
                <option value="1" selected="selected">Email</option><option value="2">SMS</option>
                <option value="3">Email and SMS</option>
            </select>
          </div>
      </div>
      <div class="onsched-form-col">
          ${element.options.labels ? '<label for="bookingNotification">Booking Notifications</label>' : ''}
          <div class="onsched-select">
            <select placeholder="Booking Notifications" class="form-control" id="bookingNotification" name="bookingNotification" value="${OnSchedHelpers.DataValue(data.bookingNotifications)}" aria-required="true" aria-invalid="false" data-post="root">
                <option value="0">None</option>
                <option value="1" selected="selected">Online Bookings</option>
                <option value="2">All Bookings &amp; Reminders</option>
            </select>
          </div>
      </div>
  </div>                          
  <div class="onsched-form-row">
      <div class="onsched-form-col">
        ${element.options.labels ? '<label for="externalCalendarId">External Calendar Email</label>' : ''}
        <input id="externalCalendarId" placeholder="External Calendar Email" type="email" name="calendarId" value="${calendarSync.id}" data-authorizedcalendar="${calendarSync.id}" data-post="options"/>
      </div>
      <div class="onsched-form-col">
        ${element.options.labels ? '<label for="calendarAvailability">Calendar Availability</label>' : ''}
        <div class="onsched-select">
            <select placeholder="Calendar Availability" class="form-control" id="calendarAvailability" name="calendarAvailability" value="${OnSchedHelpers.DataValue(data.calendarAvailability)}" data-post="options">
                <option value="0">OnSched Calendar</option>
                <option value="1">Google Calendar</option>
                <option value="2">Outlook Calendar</option>
            </select>
        </div>
      </div>
  </div>
  <div class="onsched-form-row">
        <div class="onsched-form-col">
        <p id="onsched-calendar-sync-message" class="onsched-calendar-sync-message"></p>
        </div>
    </div>
</div>
  `;
  return markup;
}

const resourceSetupAddress = (element, data) => {
  const markup = `
<div class="onsched-wizard-section">
  <div class="onsched-form-row">
      <div class="onsched-form-col">
          ${element.options.labels ? '<label for="addressLine1">Address Line 1</label>' : ''}
          <input placeholder="Address Line 1" id="addressLine1" type="text" name="addressLine1" value="${OnSchedHelpers.DataValue(data.address.addressLine1)}" data-post="address"/>
      </div>
  </div>
  <div class="onsched-form-row">
      <div class="onsched-form-col">
          ${element.options.labels ? '<label for="addressLine2">Address Line 2</label>' : ''}
          <input placeholder="Address Line 2" id="addressLine2" type="text" name="addressLine2" value="${OnSchedHelpers.DataValue(data.address.addressLine2)}" data-post="address" />
      </div>
  </div>
  <div class="onsched-form-row">
      <div class="onsched-form-col">
          ${element.options.labels ? '<label for="city">City</label>' : ''}
          <input placeholder="City" id="city" type="text" name="city" value="${OnSchedHelpers.DataValue(data.address.city)}" data-post="address"/>
      </div>
      <div class="onsched-form-col">
          ${element.options.labels ? '<label for="state">State / Province</label>' : ''}
          ${OnSchedTemplates.ProvinceSearch}
      </div>
  </div>
  <div class="onsched-form-row">
      <div class="onsched-form-col">
          ${element.options.labels ? '<label for="country">Country</label>' : ''}
          ${OnSchedTemplates.CountrySearch}
      </div>
      <div class="onsched-form-col">
          ${element.options.labels ? '<label for="postalCode">Zip / Postal Code</label>' : ''}
          <input placeholder="Zip / Postal Code" id="postalCode" type="text" name="postalCode" value="${OnSchedHelpers.DataValue(data.address.postalCode)}" data-post="address" />
      </div>
  </div>
</div>
  `;
  return markup;
}

const resourceSetupAvailability = (element, data) => {
  const markup = `
<div class="onsched-wizard-section">
  <div class="onsched-business-hours">${OnSchedTemplates.businessHoursTable(element.onsched.locale, data.availability)}</div>
</div>

  `;
  return markup;
}

const resourceSetupAvailabilityBlocks = (element, data) => {
  const markup = `
<div class="onsched-wizard-section">
  <div class="onsched-blocked-times">
    <div class="onsched-form-row">
        <div class="onsched-form-col">
            <h1 class="wizard-form-section-title">Blocked dates & times</h1>
            <p class="wizard-form-section-description">Add a single or recurring time off block (e.g. company retreat, lunch break). Blocks will restrict appointments from being booked/available during these blocked dates/times.</p>
        </div>
    </div>
    <div class="onsched-form-row">
        <div class="onsched-form-col">
            ${element.options.labels ? '<label for="blocks-startDate">Starting</label>' : ''}
            <input id="blocks-startDate" type="date" name="blocks-startDate" value="${OnSchedHelpers.CreateDateString(new Date())}" data-post="root" data-create="resource-block" />
        </div>
        <div class="onsched-form-col">
            ${element.options.labels ? '<label for="blocks-endDate">Ending</label>' : ''}
            <input id="blocks-endDate" type="date" name="blocks-endDate" value="${OnSchedHelpers.CreateDateString(new Date())}" data-post="root" data-create="resource-block" />
        </div>
    </div> 
    <div class="onsched-form-row">
        <div class="onsched-form-col">
            ${element.options.labels ? '<label for="blocks-startTime">At</label>' : ''}
            <select id="blocks-startTime" class="onsched-select" name="blocks-startTime" value="" data-post="root" data-create="resource-block">
                ${OnSchedTemplates.initTimesSelectData("en-US").map(time => 
                    `<option key="${time[0]}" value="${time[0]}">${time[1]}</option>`
                ).join('')}
            </select>
        </div>
        <div class="onsched-form-col">
            ${element.options.labels ? '<label for="blocks-endTime">Until</label>' : ''}
            <select id="blocks-endTime" class="onsched-select" name="blocks-endTime" value="" data-post="root" data-create="resource-block">
                ${OnSchedTemplates.initTimesSelectData("en-US").map(time => 
                    `<option key="${time[0]}" value="${time[0]}">${time[1]}</option>`
                ).join('')}
            </select>
        </div>
    </div>
    <div class="onsched-form-row">
        <div class="onsched-form-col">
            ${element.options.labels ? '<label for="blocks-reason">Reason</label>' : ''}
            <input id="blocks-reason" type="text" name="blocks-reason" placeholder="Reason"  value="" data-post="root" data-create="resource-block" />
        </div>
    </div>
    <div class="onsched-form-row">
        <div class="onsched-form-radio-col">
            <label class="onsched-radio" for="blocks-repeats">
                <input id="blocks-repeats" type="checkbox" name="blocks-repeats" data-post="root" data-create="resource-block" data-type="bool" />
                Repeats
            </label>
            <label class="onsched-radio" for="blocks-repeats-forever">
                <input id="blocks-repeats-forever" type="checkbox" name="blocks-repeats-forever" data-type="bool" />
                Forever
            </label>
        </div>
    </div>
    <div id="blocks-repeat-object" style="${data.repeats ? '' : 'display:none;'}">
        <div class="onsched-form-row">
            <div class="onsched-form-col">
                <label for="blocks-frequency">Repeat</label>
                <select id="blocks-frequency" class="onsched-select" name="frequency" value="D" data-post="repeat" data-create="resource-block.repeat">
                    <option value="D">Daily</option>
                    <option value="W">Weekly</option>
                    <option value="M">Monthly</option>
                </select>
            </div>
            <div class="onsched-form-col">
                <label for="blocks-interval">Every</label>
                <div class="dwm-interval">
                    <select id="blocks-interval" class="onsched-select" name="interval" value="1" data-post="repeat" data-create="resource-block.repeat">
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                    </select>
                    <span id="blocks-dwm-switch">day(s)</span>
                </div>
            </div>
        </div>
        <div class="onsched-form-row" id="blocks-weekdays-row" style="display:none">
            <div class="onsched-form-col">
                <input id="blocks-weekdays" type="hidden" name="weekdays" value="${data.repeat ? OnSchedHelpers.DataValue(data.repeat.weekdays) : ''}" data-post="repeat" data-create="resource-block.repeat" />
                <label>Weekdays</label>
                <div class="onsched-repeat-weekdays">
                ${
                    ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'].map((weekday, i) => 
                        `<label for="blocks-repeat-weekly-${weekday}" class="onsched-radio">
                            <input id="blocks-repeat-weekly-${weekday}" type="checkbox" name="repeat-weekly-${weekday}" ${data.repeat && OnSchedHelpers.CheckboxChecked(OnSchedHelpers.DataValue(data.repeat.weekdays.includes(i)))} data-type="bool" />
                            ${weekday.slice(0,3)}
                        </label>`
                    ).join("")
                }
                </div>
            </div>
        </div>
    </div>
    <div class="onsched-form-row">
        <div class="onsched-form-col">
            <button id="onsched-resource-blocks-add-block" type="button">Add Blocked Time</button>
        </div>
    </div>
    <div class="onsched-form-row">
        <div class="onsched-form-col onsched-list">
            <h5 class="wizard-form-section-description">The following times will be blocked:</h5>
            <table class="onsched-table">
                <tbody id="onsched-resource-blocks-list">
                </tbody>
            </table>
        </div>
    </div>
  </div>
</div>

  `;
  return markup;
}

const resourceSetupAvailabilityAllocations = (element, data) => {
  const markup = `
<div class="onsched-wizard-section">
  <div class="onsched-blocked-times">
    <div class="onsched-form-row">
        <div class="onsched-form-col">
            <h1 class="wizard-form-section-title">Allocated dates & times</h1>
            <p class="wizard-form-section-description">Define a single or recurring allocation that is available for booking appointments. This allocation will allow bookings to be made for these explicit dates and times only.</p>
        </div>
    </div>
    <div class="onsched-form-row">
        <div class="onsched-form-col">
            ${element.options.labels ? '<label for="allocations-startDate">Starting</label>' : ''}
            <input id="allocations-startDate" type="date" name="allocations-startDate" value="${OnSchedHelpers.CreateDateString(new Date())}" data-post="root" data-create="resource-allocation" />
        </div>
        <div class="onsched-form-col">
            ${element.options.labels ? '<label for="allocations-endDate">Ending</label>' : ''}
            <input id="allocations-endDate" type="date" name="allocations-endDate" value="${OnSchedHelpers.CreateDateString(new Date())}" data-post="root" data-create="resource-allocation" />
        </div>
    </div> 
    <div class="onsched-form-row">
        <div class="onsched-form-col">
            ${element.options.labels ? '<label for="allocations-startTime">At</label>' : ''}
            <select id="allocations-startTime" class="onsched-select" name="allocations-startTime" value="" data-post="root" data-create="resource-allocation">
                ${OnSchedTemplates.initTimesSelectData("en-US").map(time => 
                    `<option key="${time[0]}" value="${time[0]}">${time[1]}</option>`
                ).join('')}
            </select>
        </div>
        <div class="onsched-form-col">
            ${element.options.labels ? '<label for="allocations-endTime">Until</label>' : ''}
            <select id="allocations-endTime" class="onsched-select" name="allocations-endTime" value="" data-post="root" data-create="resource-allocation">
                ${OnSchedTemplates.initTimesSelectData("en-US").map(time => 
                    `<option key="${time[0]}" value="${time[0]}">${time[1]}</option>`
                ).join('')}
            </select>
        </div>
    </div>
    <div class="onsched-form-row">
        <div class="onsched-form-col">
            ${element.options.labels ? '<label for="allocations-reason">Reason</label>' : ''}
            <input id="allocations-reason" type="text" name="allocations-reason" placeholder="Reason"  value="" data-post="root" data-create="resource-allocation" />
        </div>
    </div>
    <div class="onsched-form-row">
        <div class="onsched-form-radio-col">
            <label class="onsched-radio" for="allocations-repeats">
                <input id="allocations-repeats" type="checkbox" name="allocations-repeats" data-post="root" data-create="resource-allocation" data-type="bool" />
                Repeats
            </label>
            <label class="onsched-radio" for="allocations-repeats-forever">
                <input id="allocations-repeats-forever" type="checkbox" name="allocations-repeats-forever" data-type="bool" />
                Forever
            </label>
        </div>
    </div>
    <div id="allocations-repeat-object" style="${data.repeats ? '' : 'display:none;'}">
        <div class="onsched-form-row">
            <div class="onsched-form-col">
                <label for="frequency">Repeat</label>
                <select id="allocations-frequency" class="onsched-select" name="frequency" value="D" data-post="repeat" data-create="resource-allocation.repeat">
                    <option value="D">Daily</option>
                    <option value="W">Weekly</option>
                    <option value="M">Monthly</option>
                </select>
            </div>
            <div class="onsched-form-col">
                <label for="interval">Every</label>
                <div class="dwm-interval">
                    <select id="allocations-interval" class="onsched-select" name="interval" value="1" data-post="repeat" data-create="resource-allocation.repeat">
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                    </select>
                    <span id="allocations-dwm-switch">day(s)</span>
                </div>
            </div>
        </div>
        <div class="onsched-form-row" id="allocations-weekdays-row" style="display:none">
            <div class="onsched-form-col">
                <input id="allocations-weekdays" type="hidden" name="weekdays" value="${data.repeat ? OnSchedHelpers.DataValue(data.repeat.weekdays) : ''}" data-post="repeat" data-create="resource-allocation.repeat" />
                <label>Weekdays</label>
                <div class="onsched-repeat-weekdays">
                ${
                    ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'].map((weekday, i) => 
                        `<label for="repeat-weekly-${weekday}" class="onsched-radio">
                            <input id="allocations-repeat-weekly-${weekday}" type="checkbox" name="repeat-weekly-${weekday}" ${data.repeat && OnSchedHelpers.CheckboxChecked(OnSchedHelpers.DataValue(data.repeat.weekdays.includes(i)))} data-type="bool" />
                            ${weekday.slice(0,3)}
                        </label>`
                    ).join("")
                }
                </div>
            </div>
        </div>
    </div>
    <div class="onsched-form-row">
        <div class="onsched-form-col">
            <button id="onsched-resource-allocations-add-allocation" type="button">Add Availability</button>
        </div>
    </div>
    <div class="onsched-form-row">
        <div class="onsched-form-col onsched-list">
            <h5 class="wizard-form-section-description">The following times will be available for booking:</h5>
            <table class="onsched-table">
                <tbody id="onsched-resource-allocations-list"></tbody>
            </table>
        </div>
    </div>
  </div>
</div>

  `;
  return markup;
}

export const resourceBlockedTimesList = blocks => {
    let blocksHtml = '';

    const formatEffectiveDates = b => {
        const daysTable = {
            0: 'Sun',
            1: 'Mon',
            2: 'Tue',
            3: 'Wed',
            4: 'Thu',
            5: 'Fri',
            6: 'Sat',
        }

        const frequencyTable = {
            D: 'day',
            W: 'week',
            M: 'month'
        };

        let repeats = '';
        if (b.repeats) {
            if (b.repeat.interval <= 1) {
                repeats = `Every ${frequencyTable[b.repeat.frequency]}`;
            }
            else {
                repeats = `Every ${b.repeat.interval} ${frequencyTable[b.repeat.frequency]}s`;
            }
            
            if (b.repeat.frequency === 'W') {
                repeats += ` on ${b.repeat.weekdays.split('').map(w => daysTable[w]).join(', ')}`
            }

            repeats += ' starting '
        }

        let startDate = moment(b.startDate).format('ll');
        let endDate = 'ending ' + moment(b.endDate).format('ll');
        let startTime = moment(b.startTime, 'Hmm').format('h:mm a');
        let endTime = moment(b.endTime, 'Hmm').format('h:mm a');

        if (parseInt(b.startTime) === 0) {
            startTime = '12:00 am';
        }
        else if (parseInt(b.startTime) === 30) {
            startTime = '12:30 am';
        }

        if (parseInt(b.endTime) === 0) {
            endTime = '12:00 am';
        }
        else if (parseInt(b.endTime) === 30) {
            endTime = '12:30 am';
        }

        return `${repeats} ${startDate} from ${startTime} to ${endTime} ${endDate}`;
    }

    if (blocks && blocks.length) {
        blocksHtml = `
            <tr>
                <th>Reason</th>
                <th colspan="2">Effective</th>
            </tr>
            ${blocks.map(block => `
                <tr
                    data-locationId="${block.locationId}"
                    data-startDate="${block.startDate}"
                    data-endDate="${block.endDate}"
                    data-startTime="${block.startTime}"
                    data-endTime="${block.endTime}"
                    data-reason="${block.reason}"
                    data-repeats="${block.repeats}"
                    data-frequency="${block.repeat?.frequency}"
                    data-interval="${block.repeat?.interval}"
                    data-weekdays="${block.repeat?.weekdays}"
                    data-post="${block.object.slice(8).toLowerCase()}s"
                >
                    <td>${block.reason}</td>
                    <td>${formatEffectiveDates(block)}</td>
                    <td><i data-delete="resource-${block.object.slice(8).toLowerCase()}" data-id="${block.id}" class="fad fa-trash"></i></td>
                </tr>    
            `).join('')}
        `
    }

    return blocksHtml
}

const resourceSetupCustomFields = customFields => {
  var markup = ``;
  if (customFields && customFields.length) {
      markup = `
                  <div class="onsched-wizard-section">
                          ${customFields && customFields.map((field, i) => {
                              let newRow = !(i % 2)

                              return (
                                  `
                                  ${newRow ? '<div class="onsched-form-row">' : ''}
                                                  <div class="onsched-form-col">
                                                      ${element.options.labels ? `
                                                        <label for="customField${i}">
                                                            ${OnSchedHelpers.DataValue(field.label)}
                                                        </label>
                                                      ` : ''}
                                                      <input type="text" id="customField${i}" name="field${i}" 
                                                          value="${OnSchedHelpers.DataValue(field.value)}" 
                                                          data-post="customFields" />
                                                  </div>
                                  ${newRow ? '</div>' : ''}
                                  `
                              )
                          })}                                  
                  </div>
              `
  }
  return markup;
}   
